"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackRegistrationDonePopup = trackRegistrationDonePopup;
exports.trackRegistrationDonePopupClose = trackRegistrationDonePopupClose;
exports.trackRegistrationSmsValidationFail = trackRegistrationSmsValidationFail;
exports.trackRegistrationSuccess = trackRegistrationSuccess;
exports.trackWantsSubscription = trackWantsSubscription;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _tracking = require("../../utils/tracking");
var _constants = require("./constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Успешная регистрация
 */

function trackRegistrationSuccess(_ref) {
  let {
    socialType,
    senderType,
    source,
    isProfessional
  } = _ref;
  const label = senderType ? _constants.PHONE_CODE_SENDER_TO_LABEL[senderType] : socialType || '';
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Registration',
    action: 'success',
    label
  }, (source || isProfessional) && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source,
        is_professional: isProfessional
      }
    })
  }));
}

/**
 * Подписка на новости
 */
function trackWantsSubscription(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Subscription',
    action: 'send',
    label: 'news'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Показ попапа "Отправлено письмо"
 */
function trackRegistrationDonePopup(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_email_popup_show'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Закрытие попапа "Отправлено письмо"
 */
function trackRegistrationDonePopupClose(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_email_popup_got_it'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Введен неверный код
 */
function trackRegistrationSmsValidationFail(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}